// extracted by mini-css-extract-plugin
module.exports = {"chef_house":"WelcomeBanner_chef_house__2dc8k","WelcomeBanner":"WelcomeBanner_WelcomeBanner__2YAks"};